import {Component} from '@angular/core';

@Component({
  selector: 'kt-activity',
  template: '<router-outlet></router-outlet>'
})
export class ActivityComponent {
  constructor() {
  }
}
